/**
 * User: WangMeng
 * Date: 2018-04-09
 * Time: 18:07
 * Desc: 上市公司财务情况概览
 */
import styles from './fnancialOverview.scss';
import React, { PureComponent } from 'react';
import cns from 'classnames';
import { Tabs } from 'antd';
import GroupBox from '../../common/groupBox/GroupBox';
import Geography from './financialOverview/Geography';
import Industry from './financialOverview/Industry';
import Company from './financialOverview/Company';
import Score from './financialOverview/Score';
const TabPane = Tabs.TabPane;

export default class FinancialOverview extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { options } = this.props;
        return (
            <div className="base-panel">
                <GroupBox
                    title="上市公司财务情况概览"
                >

                    <Tabs defaultActiveKey="geography" animated={false} className={cns('line-tabs margin', styles.tabs)} >
                        <TabPane tab="地理分布情况" key="geography">
                            <Geography options={options}/>
                        </TabPane>
                        <TabPane tab="行业分布情况" key="industry">
                            <Industry options={options}/>
                        </TabPane>
                        <TabPane tab="公司排名情况" key="company">
                            <Company options={options}/>
                        </TabPane>
                        <TabPane tab="评分分布情况" key="score">
                            <Score options={options}/>
                        </TabPane>
                    </Tabs>

                </GroupBox>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/regulatoryStatistical/index/FnancialOverview.jsx